import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from './../../../../auth/apigee/apigee.service';
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { OffersInNegotiationKpiCfg, OffersInNegotiationKpiCfgService } from "./offersInNegotiationKpiCfg.service";

export class OffersInNegotiationDetail {
    public employeeId: string;
    public unitId: string;
    public clientid: string;
    public centerId: string;
    public segment: string;
    public date: Date;
    public updateTimestamp: Date;
    public trading_name: string;
    public potential: string;
    public min_margin: string;
}

export class OffersInNegotiationData {
    public officeId: string;
    public nif: string;
    public name: string;
    public offersInNegotiationCount: number;
    public offersInNegotiation: OffersInNegotiationDetail[];
    public offersInNegotiationUpdateTimestamp: Date;
}

export class OffersInNegotiationServiceData {
    public consultantEntry: OffersInNegotiationData;
    public entries: OffersInNegotiationData[];
    public offersInNegotiationUpdateTimestamp: Date;
}

@Injectable()
export class OffersInNegotiationService extends KpiService<OffersInNegotiationServiceData> {
    public getClassName() { return "OffersInNegotiationService"; }

    constructor(
        private serviceCfg: OffersInNegotiationKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<OffersInNegotiationServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: OffersInNegotiationServiceData = null;
            try {
                let cfg: OffersInNegotiationKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.offersInNegotiation.summaryEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.get<OffersInNegotiationServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) {
                throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            }
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
